import { imageFile } from 'common/helpers/miscHelper';

import ProductLink from './ProductLink';

const ProductListImage = (props) => {
  const { product, width, hasLink, type, size = 'medium', index } = props;
  let image = imageFile(product.images[0].src, size);
  if (product.images[index]) {
    image = imageFile(product.images[index].src, size);
  }

  if (hasLink) {
    if (type === 'List') {
      return (
        <ProductLink displayType={type} product={product}>
          <img src={image} alt={product.title} width={width} loading="lazy" />
        </ProductLink>
      );
    }
    return (
      <ProductLink displayType="Collection" product={product}>
        <img src={image} alt={product.title} width={width} loading="lazy" />
      </ProductLink>
    );
  }

  return <img src={image} alt={product.title} width={width} loading="lazy" />;
};

export default ProductListImage;
